import { apiClient } from "./apiClient"

export const taskApi = {
    fetchTaskList: (businessEntityId, filters, config, accessToken) => {
        const componentsFilter = filters ? JSON.stringify(filters) : '{"Predicates": []}'
        const body = JSON.stringify(componentsFilter).replace("\n", "")
        return apiClient(`${config.managementServiceBaseUrl}/businessentities/${businessEntityId}/tasks/query`, accessToken, {
            method: 'POST',
            // make sure we encode the query correctly
            body: body,
            headers: {
                'Clientid': 4,
                'Shift4-Rest-Request-Envelope-Version': '1',
                'Shift4-Rest-Response-Envelope-Version': '1'
            }
        })
    }
}